import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { WithTranslation } from 'react-i18next'

import { Mutation, Query } from 'react-apollo'
import { ProjectsQuery, DeleteProjects, DuplicateProject } from './'

import get from 'lodash/get'
import isNil from 'lodash/isNil'

import { getProjectNumber } from 'utils'

import PageLayout from 'components/layout/pageLayout'
import Head from 'components/layout/head'
import Button from 'components/ui/button'
import SelectTable, { ISelectItem } from 'components/layout/selectTable'

import tableConfig from './projectsTable.config'

interface ProjectsProps extends RouteComponentProps<any>, WithTranslation {}

type ProjectsState = {}

class Projects extends Component<ProjectsProps, ProjectsState> {
  constructor(props: ProjectsProps) {
    super(props)
    this.state = {}
  }

  transformProjects = (projects: any) => {
    if (isNil(projects)) return null

    return projects.map((project: any) => {
      Object.keys(project).map((key: string) => {
        if (!isNil(project[key])) {
          switch (key) {
            case 'projectNumber': {
              project[key] = getProjectNumber(project[key])
              break
            }
          }
        }
        return null
      })
      return project
    })
  }

  render() {
    const { history } = this.props

    return (
      <PageLayout pageTitle="Projekte">
        <Head
          headline="Übersicht der Projekte"
          subheadline={
            process.env.REACT_APP_ENV === 'rigips'
              ? 'Mengenermittlung und Systemsuche - HORST'
              : 'ABK calcKit – der Baukasten für die schnelle Kalkulation'
          }
          actions={
            <Button primary onClick={() => history.push('/projects/new-project')}>
              Neues Projekt erstellen
            </Button>
          }
        />
        <div className="mb-65">
          <Query query={ProjectsQuery} fetchPolicy="network-only" notifyOnNetworkStatusChange>
            {({ loading, data }: any | null) => {
              const projects = get(data, 'getProjects', undefined)

              return (
                <Mutation mutation={DuplicateProject} refetchQueries={() => ['getProjects']}>
                  {(
                    duplicateProject: (payload: {
                      variables: { projectNumber: string; version: string }
                    }) => void,
                  ) => (
                    <Mutation mutation={DeleteProjects}>
                      {(
                        deleteProjects: (payload: {
                          variables: { projectNumber: string[] }
                        }) => void,
                      ) => (
                        <SelectTable
                          isDragDisabled
                          config={tableConfig}
                          onDelete={(items: ISelectItem[]) => {
                            const projectNumbers = items.map((item: ISelectItem) => {
                              return String(item.id)
                            })
                            deleteProjects({ variables: { projectNumber: projectNumbers } })
                          }}
                          onDuplicate={(duplicates) => {
                            duplicates.forEach((duplicate) => {
                              duplicateProject({
                                variables: {
                                  version: 'v1',
                                  projectNumber: String(duplicate.id),
                                },
                              })
                            })
                          }}
                          isLoading={loading}
                          data={this.transformProjects(projects)}
                        />
                      )}
                    </Mutation>
                  )}
                </Mutation>
              )
            }}
          </Query>
        </div>
      </PageLayout>
    )
  }
}

export default Projects
